document.addEventListener('DOMContentLoaded', () => {
  const stickyBar = document.querySelector('.cart__sticky-bar-actions');
  const buttonsWrapper = document.querySelector('.cart__footer--buttons');
  const checkoutButton = document.querySelector('.cart__footer--buttons button[name="checkout"]');

  if (!stickyBar || !buttonsWrapper || !checkoutButton) return;

  let isCheckoutInView = false;
  let isAtBottom = false;

  const toggleStickyBar = (shouldHideSourceVisible) => {
    // shouldHideSourceVisible === true → hide sticky bar
    stickyBar.classList.toggle('cart__sticky-bar-actions--show', !shouldHideSourceVisible);
  };

  const updateVisibility = () => {
    // Hide when either the default checkout area is visible
    // OR when the user is at the bottom of the page
    toggleStickyBar(isCheckoutInView || isAtBottom);
  };

  // IntersectionObserver: mirrors sticky-atc-bar behavior
  const rootMargin = `${buttonsWrapper.offsetHeight}px 0px 0px 0px`;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        isCheckoutInView = entry.isIntersecting;
        updateVisibility();
      });
    },
    {
      threshold: 1,
      rootMargin: rootMargin,
    }
  );

  observer.observe(buttonsWrapper);

  // Bottom-of-page detection
  const checkBottomOfPage = () => {
    const scrollPosition = window.innerHeight + window.scrollY;
    const pageHeight = document.documentElement.scrollHeight;
    const tolerance = 2; // px tolerance

    isAtBottom = scrollPosition >= pageHeight - tolerance;
    updateVisibility();
  };

  window.addEventListener('scroll', checkBottomOfPage, { passive: true });

  // Initial state: button visibility + bottom-of-page
  const rect = buttonsWrapper.getBoundingClientRect();
  isCheckoutInView = rect.top < window.innerHeight && rect.bottom > 0;
  checkBottomOfPage(); // sets isAtBottom and calls updateVisibility()
});